import React from 'react';
import PropTypes from 'prop-types';
import { Toolbar, IconButton, Divider, Typography } from '@material-ui/core';
import RipleyIcon from '../../../common/icons/ripleyIcon';
import { simpleUrl } from '../../../../config/paths';
import LogoutButton from '../LogoutButton';
import { useMainHeaderStyles } from './styles';

const MainHeader = ({ ...props }) => {
  const { mobile } = props;
  const classes = useMainHeaderStyles();
  return (
    <Toolbar className={classes.toolbar}>
      <IconButton edge="start" onClick={() => window.open(simpleUrl, '_blank')}>
        <RipleyIcon />
      </IconButton>
      <Divider orientation="vertical" className={classes.divider} />
      <Typography className={classes.typography} variant="h1">
        {' '}
        Mi Cuenta{' '}
      </Typography>
      <LogoutButton mobile={mobile} />
    </Toolbar>
  );
};

MainHeader.propTypes = {
  mobile: PropTypes.bool,
};

export default MainHeader;
